export default "__VITE_ASSET__Cxwul$ig__"